<template>
  <div class="suporte-button">
    <button class="btn btn-danger" @click="goToWpp()">Suporte Akdemica</button>
  </div>
</template>

<script>
export default {
  methods: {
    goToWpp: function() {
      window.open('https://wa.me/message/ZTQSJDS4OO4TM1', '_blank');
    }
  }
}
</script>

<style scoped>
  .suporte-button {
    right: -65px;
    bottom: 20%;
    z-index: 9999999;
    position: fixed;
    transform: rotate(270deg);
  }
</style>
